import _get from "lodash/get";
import styled from 'styled-components';
import { rem } from 'polished';
import formTheme from '../../styles/formTheme';
import dobInputStyles from '../../styles/dobInputStyles';
var InputMonth = styled.input.withConfig({
  displayName: "InputMonth",
  componentId: "g776mu-0"
})(["", " flex:0 0 ", ";padding-left:0.625rem;padding-right:0.25rem;text-align:center;"], dobInputStyles, function (props) {
  return rem(_get(props, "theme.form.input.fontSize", formTheme.form.input.fontSize) * 2.6);
});
export default InputMonth;